// extracted by mini-css-extract-plugin
export default {"root":"VideoCover_root__jX6RQ","video":"VideoCover_video__A6vPy","isPlaying":"VideoCover_isPlaying__4ND2S"};